import { memo } from "react";
import { useLiveStreamAppContext } from "../ContextStore/Store";

//Following Component is for Rendering Input Box for Attendees on Preview Screen
function AttendeeInputs() {
  const { userName, setUserName } = useLiveStreamAppContext();

  return (
    <>
      <div className="label-and-field attendeeScreenNameWrap">
        <label className="l-label-text" htmlFor="attendee_name">
          Screen Name:
        </label>
        <input
          className="input-w100per-mobile custom-select"
          type="text"
          name="attendee_name"
          id="attendee_name"
          value={userName}
          onChange={(e) => {
            setUserName(e.target.value);
          }}
        />
        <div className="help-text">
          Enter a name that will be displayed to the public.
        </div>
      </div>
    </>
  );
}

export default memo(AttendeeInputs);
